export default {
  "content": "<path d=\"M8 4.505a.47.47 0 00-.35.15l-5.99 5.98c-.2.2-.2.51 0 .71.2.2.51.2.71 0L8 5.715l5.63 5.63c.2.2.51.2.71 0 .2-.2.2-.51 0-.71l-5.99-5.98c-.1-.1-.23-.15-.35-.15z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};